import { FC } from "react";
import { LegacyDesktopLayout } from "./legacy";
import ScrollToTopButton from "../components/ScrollTopButton";
import { MobileLayout } from "./mobile";

interface MainLayoutProps {
    children?: React.ReactNode;
}
export const MainLayout: FC<MainLayoutProps> = ({
    children = null,
}) => {
    if (document.documentElement.clientWidth >= 1024) {
        return (
            <LegacyDesktopLayout>
                <ScrollToTopButton />
                {children}
            </LegacyDesktopLayout>
        )
    }

    return (
        <MobileLayout>
            <ScrollToTopButton />
            {children}
        </MobileLayout>
    );
}